import { CardInputWithType, ECardType, ImageInput, LinkInput } from '__generated__/globalTypes';
import { CreateGuideStoryVariables } from 'graphql/mutation/__generated__/CreateGuideStory';
import { GuideQuery_guide_stories } from 'graphql/query/__generated__/GuideQuery';

function parser(guideId: string, row: Record<string, string>): CreateGuideStoryVariables {
    const regex = new RegExp(`file/d/(.*?)/view`);
    const match = regex.exec(row['Odkaz_logo']);
    const imageUrl = match?.[1] ? 'https://drive.google.com/uc?id=' + match[1].trim() : null;

    const match1 = regex.exec(row['Odkaz_obrazek1']);
    const imageUrl1 = match1?.[1] ? 'https://drive.google.com/uc?id=' + match1[1].trim() : null;

    const match2 = regex.exec(row['Odkaz_obrazek2']);
    const imageUrl2 = match2?.[1] ? 'https://drive.google.com/uc?id=' + match2[1].trim() : null;

    const match3 = regex.exec(row['Odkaz_obrazek3']);
    const imageUrl3 = match3?.[1] ? 'https://drive.google.com/uc?id=' + match3[1].trim() : null;

    const match4 = regex.exec(row['Odkaz_obrazek4']);
    const imageUrl4 = match4?.[1] ? 'https://drive.google.com/uc?id=' + match4[1].trim() : null;

    const mutationPayload: CreateGuideStoryVariables = {
        guideId,
        story: {
            importKey: row['ID'],
            header: {
                title: row['Nazev_firmy'],
                text: row['Popisek'],
                imageUrl
            }
        },
        cards: []
    };
    const linkCard: CardInputWithType = {
        type: ECardType.LINK,
        links: (() => {
            const links: LinkInput[] = [];

            links.push({
                title: 'Webová stránka',
                url: row['Webovka']
            });

            if (row['Facebook']) {
                links.push({
                    title: 'Facebook',
                    url: row['Facebook']
                });
            }

            if (row['Linkedin']) {
                links.push({
                    title: 'Linkedin',
                    url: row['Linkedin']
                });
            }

            if (row['Instagram']) {
                links.push({
                    title: 'Instagram',
                    url: row['Instagram']
                });
            }

            if (row['Youtube']) {
                links.push({
                    title: 'Youtube',
                    url: row['Youtube']
                });
            }

            return links;
        })()
    };

    const imageCard: CardInputWithType = {
        type: ECardType.IMAGE,
        images: (() => {
            const images: ImageInput[] = [];

            if (imageUrl1) {
                images.push({
                    imageUrl: imageUrl1
                });
            }
            if (imageUrl2) {
                images.push({
                    imageUrl: imageUrl2
                });
            }
            if (imageUrl3) {
                images.push({
                    imageUrl: imageUrl3
                });
            }
            if (imageUrl4) {
                images.push({
                    imageUrl: imageUrl4
                });
            }

            return images;
        })()
    };

    mutationPayload.cards.push(linkCard);
    if (imageCard?.images.length > 0) {
        mutationPayload.cards.push(imageCard);
    }

    return mutationPayload;
}

function duplicateChecker(story: GuideQuery_guide_stories, row: Record<string, string>): boolean {
    return story.importKey?.toLowerCase() === row['ID']?.toLowerCase();
}

export const expoImportMethods = { duplicateChecker, parser };
